<template>
   <vs-row vs-justify="center">
    <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
      
      <vs-card>
        <div class="d-md-flex align-items-center pb-2">
        <h3 class="card-title mb-0">Penugasan Kurir</h3>
        <div class="ml-auto">
          
        </div> 
        </div>
        <vs-alert v-if="errors.length" class="mb-3 mt-2"  color="danger">
            <b>Terdapat Kesalahan..</b>
            <ul class="common-list">
            <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
        </vs-alert>
          <vs-tabs alignment="fixed" :value="activeTab">
            <vs-tab icon="subject" label="Sudah diberikan ke kurir" @click="activeTab=0">
                <div class="cetak">
                    <JqxGrid ref="myGrid" :autorowheight="true" :autoheight="true"
                        :width="width" :theme="'material-green'" :selectionmode="'singlerow'" 
                        :pageable="true" :sortable="true" :filterable="true" :showfilterrow="true" :columnsresize="true"
                        :source="dataAdapter" :columns="columns" 
                    />
                </div>
                
            </vs-tab>
            
            <vs-tab icon="web" label="Belum diberikan ke kurir">
                <div>
                    
                    <vs-table  :data="formdata.datatrans" class="text-nowrap">
                        <template slot="thead">
                            <vs-th>Tujuan Kecamatan</vs-th>
                            <vs-th>Jumlah Resi</vs-th>
                            <vs-th>Penugasan Kurir</vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr class="border-top" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td vs-align="right">
                                {{data[indextr].dkec_nama}}
                            </vs-td>
                            <vs-td vs-align="right">
                                {{data[indextr].jum_resi}}
                            </vs-td>
                            <vs-td>
                                <vs-select class="w-100 " v-model="data[indextr].kurir_antar">
                                <vs-select-item
                                    :key="index"
                                    :value="item.id"
                                    :text="item.name"
                                    v-for="(item,index) in optkurir"
                                />
                                </vs-select>
                            </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
                <div class="btn-alignment mt-4">
                <vs-button color="success" type="filled" @click.stop.prevent="checkForm">Simpan</vs-button>
                <vs-button color="dark" @click="backpage" type="filled">Batal</vs-button>
                </div>
            </vs-tab>
            
        </vs-tabs>
        <hr class="custom-hr" />
        
      </vs-card>
    </vs-col>
    
   </vs-row>
</template>

<script>
  import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";
  
  export default {
    components: {
      JqxGrid,
    },
    
    data: function () {
      return {
        // eslint-disable-next-line
        dataAdapter: new jqx.dataAdapter(this.source, {
            formatData: function (data) {
                return  JSON.stringify(data);
            },
            beforeSend: function (jqxhr, settings) { 
                settings.xhrFields = {
                    withCredentials: true
                },
                jqxhr.setRequestHeader("X-XSRF-TOKEN",window.$cookies.get('XSRF-TOKEN'))
            }
        }),
        width: "100%",
        columns: [
          { text: 'No Resi', datafield: 'kirim_no', width: '15%' },
          { text: 'Nama Pengirim', datafield: 'nama_pengirim', width: '10%'},
          { text: 'Asal', filtertype: 'list', filteritems: this.items, datafield: 'kab_asal', width: '15%'},
          { text: 'CASH / COD', filtertype: 'list', filteritems: this.items, datafield: 'bayar', width: '10%'},
          { text: 'Kabupaten Tujuan', filtertype: 'list', filteritems: this.items, datafield: 'kab_id', width: '10%'},
          { text: 'Kecamatan Tujuan', filtertype: 'list', filteritems: this.items, datafield: 'kec_id', width: '10%'},
          { text: 'Status', filtertype: 'list', filteritems: this.items, datafield: 'status', width: '20%'},
          { text: 'Kurir', filtertype: 'list', filteritems: this.items, datafield: 'kurir', width: '10%'},
        ],
        selectrow: 0,
        formdata: {
            no_kirim:'',
            office_id:this.$store.getters.getOffice,
            opr:'',
            datatrans:[],
            isEdit: false,
            prevReferensi:'',
            po_no:'',
            sj_no:''
        },
        optkurir:[],
        activeTab: 0,
        jenis:'',
        barang:'',
        satuan:'',
        qty:'',
        catatan:'',
        dk:true,
        transval:'',
        errors:[],
        errorPerkiraan:false,
        errorBarang:false,
        errorQty:false,
        numSumDebet:0,
        numSumKredit:0,
        idtrans:0,
        
        //formatTgl:''
      }
    },
    methods:{
        backpage: function(){
            this.$router.go(-1);
        },
        getkurir:function(){
            this.$http.get('/api/listkurir').then(response => {
                console.log(response.data)
                this.optkurir = response.data;
            }).catch(error=>{
                this.$vs.notify({title:'Error',text:'Gagal inisiasi data, silahkan coba lagi...',color:'danger'})
            });
        },
        getListnokurir: function(){
            this.$http.get('/api/listnokurir').then(response => {
                console.log(response.data)
                this.formdata.datatrans = response.data;
            }).catch(error=>{
                this.$vs.notify({title:'Error',text:'Gagal inisiasi data, silahkan coba lagi...',color:'danger'})
            });
        },
        checkForm:function(e) {
            this.errors = [];
            //cek dari client dulu...
           
            this.$vs.loading({'type':'radius'})
            this.$http.post('/api/setkurir',{
                formdata : this.formdata
            }).then(response => {
                console.log(response);
                this.handleSuccess();
                //
            }).catch(error=>{
                console.log(error)
                this.handleError(error)
            })
        },
        handleError: function(error,type=''){
            if(type != 'local'){
                if (error.response != null){
                    let status = error.response.status
                    console.log(status)
                    switch(status){
                        case 422 :
                            const keys = Object.keys(error.response.data.errors)
                            //console.log(keys);
                            for(const key of keys){
                                //console.log(key)
                                //console.log(error.response.data.errors[key][0])
                                this.errors.push(error.response.data.errors[key][0])
                            }
                        break
                        case 500 :
                            this.errors.push('Internal server error.. silahkan hubungi administrator')
                            break
                        default:
                            break
                    }
                }
            }
            console.log('handle error')
            this.notify()
            this.$vs.loading.close()
        },
        handleSuccess: function(){
            this.$vs.loading.close()
            this.$vs.notify({title:'Success',text:'Data berhasil disimpan..',color:'success'})
            this.$router.go();
            this.formdata.no_kirim = ""
            //this.$refs.myGrid.updatebounddata();
            this.formdata.no_kirim = ''
        },
        notify: function(){
            this.$vs.notify({
                title:'Gagal Menyimpan Data',
                text:'Click untuk melihat',
                color:'danger',
                fixed:false,
                icon: 'warning',
                click:()=>{
                    window.scrollTo(0,0);
                },
            })
        }
    },
    beforeCreate: function () {
      this.source = {
        datafields: [
          { name: 'kirim_no', type: 'string'},
          { name: 'kirim_tgl', type: 'date'},
          { name: 'nama_pengirim', type: 'string'},
          { name: 'alamat_penerima', type: 'string'},
          { name: 'bayar', type: 'string'},
          { name: 'kab_asal', map: 'kab_nama'},
          { name: 'kab_id', map: 'dkab_nama'},
          { name: 'kec_id', map: 'dkec_nama'},
          { name: 'leadtime', type: 'date'},
          { name: 'status', map: 'status_name'},
          { name: 'kurir', map: 'name'},
        ],
        datatype: 'json',
        id: 'referensi',
        url: this.$urlbackend+'/api/listwithkurir',
        type: 'post',
        deleterow: function (rowid, commit) {
            commit(true);
        }
      }
      this.editrow = -1;
    },
    
    computed: {
        options () {
            return {
                locale: this.locale,
                currency: this.currency
            }
        }
    },
    watch:{
        'formdata.no_kirim': function(){
            this.scanBarcode();
        },
    },
    mounted: function () {
        this.getListnokurir();
        this.getkurir();
    },
    
  }
</script>
<style src='@/assets/styles/jqwidgets/jqx.base.css'></style>